import React, { PureComponent, ReactNode } from 'react'
import ContentPage from './ContentPage'
import { permitBreadcrumbs, TPermitCategoryKeys } from '../../../permitsStatic'
import { Button } from 'react-bootstrap'
import './ContentSubheader.scss'
import { useTranslation } from 'react-i18next'
import { TFunction } from 'i18next'
interface PropsPC {
  title: string
  isMainHeader?: boolean
  filterBy?: (permitCategory?: TPermitCategoryKeys) => void
  showRemoveFilter?: boolean
  className?: string

  locale: string;
  t: TFunction;
}

class ContentSubheaderPC extends PureComponent<PropsPC> {
  constructor(props: PropsPC) {
    super(props)
  }

  filterBy(pc?: TPermitCategoryKeys) {
    if (this.props.filterBy) {
      this.props.filterBy(pc)
    }
  }

  get breadcrumbs() {
    const breadcrumbs = permitBreadcrumbs(this.props.locale)
    return breadcrumbs.map((b, i) => (
      <div key={`subheader-a-${i}`} className="d-flex">
        {
          this.props && this.props.filterBy &&
          <span onClick={() => {this.filterBy(b.url as TPermitCategoryKeys)}} className="kt-subheader__breadcrumbs-link pr-0 cursor-pointer">{ b.title }</span>
        }
        <span className={i < breadcrumbs.length-1 ? `kt-subheader__breadcrumbs-separator px-3` : ''}></span>
      </div>
    ))
    return
  }

  render(): ReactNode {
    return (
      <div className={`content-subheader kt-subheader kt-grid__item py-2`}>
        <div className="kt-subheader__main">
          {
            this.props.isMainHeader ?
            <h1 className="kt-subheader__title text-dark">{this.props.title}</h1> :
            <h2 className="kt-subheader__title text-dark">{this.props.title}</h2>
          }
          <span className="kt-subheader__separator kt-hidden"></span>
          {
            !this.props.showRemoveFilter && this.props.filterBy &&
            <div className="kt-subheader__breadcrumbs d-none d-sm-none d-md-flex">
              <span className="kt-subheader__breadcrumbs-home"><i className="flaticon2-notepad"></i></span>
              {
                this.breadcrumbs
              }
            </div>
          }
          {
            this.props.showRemoveFilter &&
            <Button className="btn-sm" onClick={() => this.filterBy()}>{this.props.locale === "lt"? "valyti filtrą" : "clear filter" }<i className="la la-close"></i></Button>
          }
        </div>
      </div>
    )
  }
}

interface Props {
  title: string
  isMainHeader?: boolean
  filterBy?: (permitCategory?: TPermitCategoryKeys) => void
  showRemoveFilter?: boolean
  className?: string
}

export const ContentSubheader: React.FC<Props> = ({title, isMainHeader, filterBy, showRemoveFilter, className}) => {

  const { t, i18n } = useTranslation();

  return (
		<ContentSubheaderPC title={title} isMainHeader={isMainHeader} filterBy={filterBy} showRemoveFilter={showRemoveFilter} className={className} locale={i18n.language} t={t} />
	);
}

export default ContentSubheader;
